import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Check if the experimental API is available before importing
let experimental_taintUniqueValue;
try {
  experimental_taintUniqueValue = require('react').experimental_taintUniqueValue;
} catch (e) {
  // Function not available, create a no-op function
  experimental_taintUniqueValue = () => {};
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Protect API key from being passed to client components
if (typeof window === 'undefined' && experimental_taintUniqueValue) { // Server-side check
  experimental_taintUniqueValue(
    'Do not pass Firebase API key to client components directly.',
    process,
    process.env.REACT_APP_FIREBASE_API_KEY
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { db, auth, googleProvider };
